<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiContentCopy } from "@mdi/js";
export default {
  name: "MdiContentCopy",
  data() {
    return {
      svgPath: mdiContentCopy,
    };
  },
};
</script>
